import { Drawer as DrawerPrimitive, DrawerContent, DrawerHeader, DrawerTitle } from "@/components/ui/drawer";

// Design System 2.0 (2026-10, Phase 1) — the brief's "Drawer (420px right)" preset over the
// already-installed (but previously unused) vaul-based drawer.jsx. First real consumer:
// AdminOpportunities.jsx (Phase 6, Job D).
export function Drawer({ open, onOpenChange, title, children, testId }) {
  return (
    <DrawerPrimitive open={open} onOpenChange={onOpenChange} direction="right">
      <DrawerContent
        data-testid={testId}
        // Esc closes the drawer, but never while the user is typing/choosing inside a form
        // field in it (same rule Job A applied to the Recce fullscreen Esc guard).
        onEscapeKeyDown={(e) => {
          const tag = document.activeElement?.tagName;
          if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") e.preventDefault();
        }}
        className="inset-x-auto right-0 top-0 bottom-0 mt-0 h-full w-[420px] max-w-full rounded-t-none rounded-l-md border-l border-hairline shadow-[0_16px_48px_rgba(17,17,17,.18)]"
      >
        {title && (
          <DrawerHeader className="text-left border-b border-hairline">
            <DrawerTitle className="font-editorial text-[24px] leading-[30px] -tracking-[0.015em]">{title}</DrawerTitle>
          </DrawerHeader>
        )}
        <div className="flex-1 overflow-y-auto p-4">{children}</div>
      </DrawerContent>
    </DrawerPrimitive>
  );
}
